<template>
    <div class="dialog">
        <div v-show="validationShow" class="mask"></div>
        <div v-show="validationShow" class="dialog-content">
            <span class="close" @click="closeModal">×</span>
            <h3>{{ _ll('图形验证码') }}</h3>
            <div class="form-group">
                <img :src="imgVrfCodePicUrl" :alt="_ll('图形验证码图片')" class="imgVrfCodePic" tabindex="0" @click="getImgVrfCodePic" />
            </div>
            <div v-show="imgVrfCodetipShow" class="error-tip">{{ imgVrfCodetips }}</div>
            <div class="form-group">
                <input v-model="verificationCode" type="text" :placeholder="_ll('请输入图片中的验证码')" @keydown="disableEnter" />
            </div>
            <div class="form-group text-center">
                <button type="button" class="primary-btn" @click="submit">{{ _ll('确定') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '../../api/ajax'

export default {
    name: 'Validation',
    props: ['mobile'],
    data() {
        return {
            imgVrfCodePicUrl: this.getRefreshCodeUrl(),
            imgVrfCodetipShow: false,
            verificationCode: '',
            validationShow: false,
            imgVrfCodetips: ''
        }
    },
    methods: {
        show() {
            this.validationShow = true
            this.imgVrfCodetipShow = false
            this.verificationCode = ''
            this.imgVrfCodePicUrl = this.getRefreshCodeUrl()
        },
        close() {
            this.validationShow = false
        },
        getRefreshCodeUrl() {
            return `/sf-service-owf-web/service/captcha/sms?force=true&time=${new Date().getTime()}`
        },
        submit() {
            const reg = /^[A-Za-z0-9]{5}$/
            //
            // 验证格式
            if (!reg.test(this.verificationCode)) {
                this.verificationCode = ''
                this.imgVrfCodetips = this._ll('请输入正确的验证码')
                this.imgVrfCodetipShow = true
                this.getImgVrfCodePic()
            } else {
                // 调用函数
                ajax.smsUserNotification({
                    params: {
                        mobile: this.mobile,
                        answer: this.verificationCode,
                        app: 'sms',
                        area: ''
                    }
                })
                    .then(res => {
                        this.verificationCode = ''
                        this.$emit('getCodeSuccess')
                        this.validationShow = false
                    })
                    .catch(res => {
                        this.renderValidationFailed(res)
                    })
                    .finally(() => {
                        this.getImgVrfCodePic()
                    })
            }
        },
        renderValidationFailed: function (res) {
            let errorMsg = ''
            if (res.response.status == 403) {
                this.verificationCode = ''
                this.imgVrfCodetips = this._ll('请输入正确的验证码')
                this.imgVrfCodetipShow = true
            } else {
                if (res.response.status == 410) {
                    errorMsg = '该手机号本日已达到发送短信上限'
                } else if (res.response.status == 400) {
                    // this.$('#login_mobile').focus();
                    errorMsg = '手机号错误'
                } else {
                    errorMsg = '获取验证码失败'
                }
                this.validationShow = false
                this.$emit('getCodeError', errorMsg) // 关闭弹出框
            }
        },
        getImgVrfCodePic: function () {
            this.imgVrfCodePicUrl = this.getRefreshCodeUrl()
        },
        closeModal: function () {
            this.validationShow = false
        },
        disableEnter: function (e) {
            if (e.keyCode === 13) {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50001;
    background: rgba(0, 0, 0, 0.5);
}
.dialog-content {
    position: fixed;
    padding: 20px;
    width: 500px;
    left: 50%;
    top: 38%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    background: $white;
    z-index: 50002;
}
img {
    width: 100%;
}
.close {
    float: right;
    text-align: center;
    font-size: 80px;
    line-height: 50px;
    height: 50px;
    width: 50px;
    color: $gray;
    position: relative;
    right: 0;
    top: 0;
}
.form-group {
    margin-top: 20px;
}
.error-tip {
    color: $red;
    margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/validation/validation.vue